import React, { createContext, useContext } from "react";

interface MobileNavContextType {
  closeMobileNav?: () => void;
}

const MobileNavContext = createContext<MobileNavContextType>({});

export const MobileNavProvider: React.FC<{
  children: React.ReactNode;
  closeMobileNav?: () => void;
}> = ({ children, closeMobileNav }) => {
  return (
    <MobileNavContext.Provider value={{ closeMobileNav }}>{children}</MobileNavContext.Provider>
  );
};

export const useMobileNav = () => {
  return useContext(MobileNavContext);
};
